import React from 'react';
import withStyles from '@material-ui/core/styles/withStyles';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import FormGroup from '@material-ui/core/FormGroup';
import CircularProgress from '@material-ui/core/CircularProgress';
import Word from '../../../containers/Common/Word'
import { WID } from '../../../constants/Language'

const styles = theme => ({
  image: {
    width: '100%',
    height: '100%', 
    maxWidth: '400px',
    marginBottom: '20px'
  },
});

class DownloadImageDialog extends React.Component {  

  render() {
    const { classes, open, image, handleClose, handleEnter, handleEntered, handleExited } = this.props

    return (
      <Dialog
          open={open}
          onClose={handleClose}
          onEnter={handleEnter}
          onEntered={handleEntered}
          onExited={handleExited}
      >
          <DialogTitle id="settings-dialog-title"><Word wid={WID.DOWNLOAD_IMAGE_DIALOG.DIALOG_TITLE}/></DialogTitle>
          <DialogContent>
            {image === '' && (
              <div style={{textAlign: 'center'}}>
                <CircularProgress className={classes.progress} />
              </div>
            )}
            {image !== '' && (
              <FormGroup>
                <img className={classes.image} src={image} alt='download'/>
              </FormGroup>
            )}
          </DialogContent>
          <DialogActions>
          {image !== '' && (
            <Button variant="contained" color="primary" href={image} download={"renjuboard.png"}>
              <Word wid={WID.DOWNLOAD_IMAGE_DIALOG.DOWNLOAD_BUTTON}/>
            </Button>
          )}
          <Button onClick={handleClose} color="primary" autoFocus>
              Close
          </Button>
          </DialogActions>
      </Dialog>
    );
  }
}

export default withStyles(styles)(DownloadImageDialog);


// WEBPACK FOOTER //
// ./src/components/Common/RenjuBoardCard/DownloadImageDialog.js